module.exports = __webpack_public_path__ + "static/young-leader-photo-anabelle_torek-05f858926aefee226e9736982b6a41d1.jpg";